module.exports = __webpack_public_path__ + "img/parc1@2x.50941861.png";